module.exports = __webpack_public_path__ + "static/media/wood.c628afe8.png";